<div *ngIf="navItems && leftNavV2Flag; else navV1Template" class="leftNav-wrapper v2">
  <div *ngIf="isMobileView; else isWebView">
    <div class="dropdown">
      <button class="drop-down-menu-button v2" type="button" id="dropdownMenuButton" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false">
        {{ SELECTED_NAV }}
        <img src="ocsp-web-ui/dist/assets/images/icon/Universal/caret-down/gray.svg" class="float-right"
          alt="dropdown caret" />
      </button>
      <div class="dropdown-menu v2" aria-labelledby="dropdownMenuButton" role="list">
        <a [attr.aria-label]="'item ' + (ind) + ' ' + navItems.title?.text"
          role="listitem"
          [ngClass]="getNavbarClass(navItems.title?.className)"
          [href]="navItems.title?.link" 
          [attr.aria-current]="navItems.title?.isActive ? 'page' : null">
        {{ navItems.title?.text }}
        </a>
        <ng-container *ngFor="let leftMenuItem of navItems.leftMenuItems">
          <div *ngFor="let menuItem of leftMenuItem?.menuItems; let ind = index">
            <a [attr.aria-label]="'item ' + (ind + 1) + ' ' + menuItem.leftNavText" role="listitem"
              [ngClass]="getNavbarClass(menuItem.className)"
              [attr.data-eot-flag]="menuItem.eotFlagName ? menuItem.eotFlagName : ''" [href]="menuItem.leftNavLink"
              [attr.aria-current]="menuItem.isActive ? 'page' : ''">
              {{ menuItem.leftNavText }}
            </a>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template #isWebView>
    <nav class="nav flex-column ml16">
      <a class="navbar-hyperlink navbar-v2 title mb-3" [class.active]="navItems.title?.isActive" role="heading"
        aria-level="2" [href]="navItems.title?.link" [attr.aria-current]="navItems.title?.isActive ? 'page' : null">
        {{ navItems.title?.text }}
      </a>
      <div *ngFor="let leftMenuItem of navItems.leftMenuItems; let ind = index">
        <div class="d-flex mb-3">
          <img [src]="leftMenuItem?.groupIcon" class="leftnav-group-icon" [alt]="leftMenuItem?.alt || null"
            [attr.aria-label]="leftMenuItem?.ariaLabel || null">
          <p [attr.id]="leftMenuItem.id" [attr.tabindex]="leftMenuItem.tabIndex"
            [ngClass]="['navbar-group-title my-auto ml-2', leftMenuItem.className? leftMenuItem.className : 'body-m']"
            [attr.role]="leftMenuItem.role" [attr.aria-live]="leftMenuItem.ariaLive"
            [attr.aria-level]="leftMenuItem.ariaLevel">
            {{ leftMenuItem.groupTitle }}
          </p>
        </div>
        <div *ngFor="let menuItem of leftMenuItem?.menuItems; let index = index">
          <ng-container *ngIf="menuItem.eotDrivenLink || window?.AB?.userInfo?.isARenrolled">
            <ng-container *ngIf="getEOTFlag(menuItem.eotFlagName) === 'b'">
              <div class="my-3">
                <a [attr.aria-label]="'item ' + (index + 1) + ' ' + menuItem.leftNavText"
                  [ngClass]="getMenuItemClassNames(menuItem.classNames, menuItem.isActive)"
                  (mouseenter)="onMouseOver($event)" (mouseleave)="onMouseOut($event)"
                  [attr.data-eot-flag]="menuItem.eotFlagName" [href]="menuItem.leftNavLink"
                  [attr.aria-current]="menuItem.ariaCurrent">
                  {{ menuItem.leftNavText }}
                </a>
                <p *ngIf="menuItem?.showAddLabel" [attr.id]="menuItem.id" [attr.tabindex]="menuItem.tabIndex"
                  [ngClass]="getBadgeClassNames(menuItem.classNames)" [attr.role]="menuItem.role"
                  [attr.aria-live]="menuItem.ariaLive" [attr.aria-level]="menuItem.ariaLevel">
                  {{ badgeText }}
                </p>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!(menuItem.eotDrivenLink || window?.AB?.userInfo?.isARenrolled)">
            <div class="my-3">
              <a [attr.aria-label]="'item ' + (index + 1) + ' ' + menuItem.leftNavText"
                [ngClass]="getMenuItemClassNames(menuItem.classNames, menuItem.isActive)"
                (mouseenter)="onMouseOver($event)" (mouseleave)="onMouseOut($event)" [href]="menuItem.leftNavLink"
                [attr.aria-current]="menuItem.ariaCurrent">
                {{ menuItem.leftNavText }}
              </a>
              <p *ngIf="menuItem?.showAddLabel" [attr.id]="menuItem.id" [attr.tabindex]="menuItem.tabIndex"
                [ngClass]="getBadgeClassNames(menuItem.classNames)" [attr.role]="menuItem.role"
                [attr.aria-live]="menuItem.ariaLive" [attr.aria-level]="menuItem.ariaLevel">
                {{ badgeText }}
              </p>
            </div>
          </ng-container>
        </div>
        <hr *ngIf="ind !== navItems.leftMenuItems.length - 1" class="my-3 mr-2 divider-left-nav" />
      </div>
    </nav>
  </ng-template>
</div>


<ng-template #navV1Template>
  <div *ngIf="leftNavOptions" class="uca-navigation aem-GridColumn aem-GridColumn--default--12">
    <div class="d-block d-md-block d-lg-none show-mobile mobile-width">
      <div class="simple-page-title section">
        <div style="margin-left: 0px">
          <div>
            <div class="title-bg">
              <h1 class="uca-title-mobile">{{leftNavOptions.navtitle}}</h1>
            </div>
          </div>
        </div>
        <cq
          data-config="{&quot;path&quot;:&quot;/content/www/tomthumb/en/justforu/jcr:content/root/responsivegrid/column_control/par_1/simple_page_title&quot;,&quot;slingPath&quot;:&quot;/content/www/tomthumb/en/justforu/jcr:content/root/responsivegrid/column_control/par_1/simple_page_title.html&quot;,&quot;dialog&quot;:&quot;/apps/wcax-commons/components/content/simple-page-title/v1/simple-page-title/cq:dialog&quot;,&quot;dialogLoadingMode&quot;:&quot;auto&quot;,&quot;dialogLayout&quot;:&quot;auto&quot;,&quot;dialogSrc&quot;:&quot;/mnt/override/apps/wcax-commons/components/content/simple-page-title/v1/simple-page-title/_cq_dialog.html/content/www/tomthumb/en/justforu/jcr:content/root/responsivegrid/column_control/par_1/simple_page_title&quot;,&quot;type&quot;:&quot;wcax-commons/components/content/simple-page-title/simple-page-title&quot;,&quot;isResponsiveGrid&quot;:false,&quot;policyPath&quot;:&quot;root/responsivegrid/wcax-commons/components/content/simple-page-title/simple-page-title&quot;,&quot;csp&quot;:&quot;www-page|page/root|responsivegrid/responsivegrid/column-control/par_1|parsys/simple-page-title&quot;}"
          data-path="/content/www/tomthumb/en/justforu/jcr:content/root/responsivegrid/column_control/par_1/simple_page_title">
        </cq>
      </div>
      <div class="product-level-4 d-block d-md-block show-mobile">
        <h2 class="sub-banner d-none">
          <a aria-current="location" class="active"
            href="https://www-qa1.tomthumb.com/account/account-settings.html">Account Settings</a>
        </h2>
        <div aria-label="secondary navigation" class="dropdown left-nav-mobile-container">
          <button aria-controls="dropdownMenu" aria-expanded="false" aria-haspopup="true" aria-label="dropdownButton"
            class="btn btn-default dropdown-toggle nav-item-left d-block d-md-block" data-toggle="dropdown"
            id="dropdownMenuButton" role="button" type="button">
            <div class="float-left active-list-item-v1" id="paymentMethodSelectText">
              FreshPass
            </div>
            <div aria-hidden="true" class="svg-icon svg-icon-Arrow_down_black float-right dropdown-caret-leftnav"
              role="img"></div>
          </button>
          <ul aria-labelledby="dropdownMenuButton" class="dropdown-menu" id="dropdownMenu" role="list">
            <li *ngFor="let navItem of leftNavOptions.leftnav; let i = index"
              class="list-group-item mobile-list-styling" role="listitem" tabindex="0">
              <a href="{{navItem.link}}" role="listitem" tabindex="0">{{navItem.linktitle}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="acc-page d-none d-md-none d-lg-block hide-mobile">
      <div class="panel-group d-block d-md-none menu-tree" id="accordion">
        <div class="panel panel-default list-grp-bck">
          <div aria-expanded="false" class="panel-heading accordion-toggle collapsed" data-parent="#accordion"
            data-target="#collapseOne" data-toggle="collapse">
            <h4 class="panel-title"><span>{{leftNavOptions.navtitle}}</span></h4>
          </div>
          <div aria-expanded="false" class="panel-collapse collapse" id="collapseOne" style="height: 0px;">
            <ul class="list-group list-grp-bck">
              <li *ngFor="let navItem of leftNavOptions.leftnav; let i = index"
                class="list-group-item mobile-list-styling">
                <a [ngClass]="{'active': navItem.link.indexOf('freshpass') >= 0}" aria-current="false"
                  class="user-protected-link user-prompt-a user-prompt-g user-prompt-r" href="{{navItem.link}}"
                  role="link">
                  {{navItem.linktitle}}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  rewards d-none d-md-block hide-mobile">
        <div aria-expanded="false" class="navbar-collapse" id="myNavbar">
          <nav aria-label="secondary navigation" class="menu-tree">
            <h2>{{leftNavOptions.navtitle}}</h2>
            <ul class="nav navbar-nav">
              <li *ngFor="let navItem of leftNavOptions.leftnav; let i = index">
                <a [ngClass]="{'active': navItem.link.indexOf('delivery-subscription') >= 0}" aria-current="false"
                  class="user-protected-link user-prompt-a user-prompt-g user-prompt-r" href="{{navItem.link}}"
                  role="link" tabindex="0">
                  {{navItem.linktitle}}
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</ng-template>